import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ChevronRight, ArrowRight, Building2, Phone } from 'lucide-react';
import { ContactCTA } from '../components/ContactCTA';
export function CommercialPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const services = [{
    title: 'Silicone Roof Coatings',
    slug: 'silicone',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80',
    description: 'Extend the life of your existing flat roof by up to 20 years with a seamless silicone coating that eliminates leaks and reflects UV heat.'
  }, {
    title: 'TPO Roofing Systems',
    slug: 'tpo',
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&q=80',
    description: 'Thermoplastic polyolefin single-ply membrane roofing — energy-efficient, durable, and ideal for Michigan commercial buildings.'
  }, {
    title: 'EPDM Roofing Systems',
    slug: 'epdm',
    image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=600&q=80',
    description: 'Synthetic rubber roofing membrane known for its exceptional durability and resistance to extreme temperatures and weather.'
  }, {
    title: 'Commercial Roof Repair',
    slug: 'repair',
    image: 'https://images.unsplash.com/photo-1632759145351-1d592919f522?w=600&q=80',
    description: 'Fast, reliable repairs for all commercial roof types — from minor leak fixes to major storm damage restoration.'
  }];
  return <div className="w-full bg-white" data-id="element-595">
      {/* Hero */}
      <section className="relative min-h-[45vh] flex items-center pt-20 pb-16 overflow-hidden" data-id="element-596">
        <div className="absolute inset-0 z-0" data-id="element-597">
          <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1920&q=80" alt="" className="absolute inset-0 w-full h-full object-cover" data-id="element-598" />
          <div className="absolute inset-0 bg-brand-blue/15 z-[1]" data-id="element-599"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-black/30 z-[2]" data-id="element-600"></div>
        </div>
        <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-601">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-3xl" data-id="element-602">
            <nav className="flex items-center text-sm text-gray-300 font-body mb-6" data-id="element-603">
              <Link to="/" className="hover:text-brand-blue transition-colors" data-id="element-604">
                Home
              </Link>
              <ChevronRight size={16} className="mx-2" data-id="element-605" />
              <span className="text-white font-semibold" data-id="element-606">
                Commercial Roofing
              </span>
            </nav>
            <div className="inline-flex items-center gap-2 bg-brand-blue/20 border border-brand-blue/50 text-white px-4 py-1.5 rounded-full font-body text-sm font-bold mb-6 backdrop-blur-sm" data-id="element-607">
              <Building2 size={16} data-id="element-608" />
              Commercial Division
            </div>
            <h1 className="font-heading font-black text-4xl md:text-5xl lg:text-6xl text-white leading-tight mb-6" data-id="element-609">
              Commercial{' '}
              <span className="text-brand-blue" data-id="element-610">Roofing Solutions</span>
            </h1>
            <p className="font-body text-xl text-gray-200 mb-8 max-w-2xl leading-relaxed" data-id="element-611">
              Flat roof systems, coatings, and repairs for businesses,
              warehouses, and multi-unit properties across Southeast Michigan.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-612">
              <a href="#quote" className="bg-brand-blue hover:bg-brand-blue-dark text-white font-body font-bold text-lg py-4 px-8 rounded-lg text-center transition-colors shadow-lg" data-id="element-613">
                Request a Commercial Quote
              </a>
              <a href="tel:5862033701" className="bg-white/10 hover:bg-white text-white hover:text-brand-blue border-2 border-white backdrop-blur-sm font-body font-bold text-lg py-4 px-8 rounded-lg text-center transition-all flex items-center justify-center gap-2" data-id="element-614">
                <Phone size={20} data-id="element-615" /> (586) 203-3701
              </a>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-gray-50" data-id="element-616">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-617">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-618">
            <h2 className="font-heading font-bold text-3xl md:text-4xl text-brand-gray-dark mb-4" data-id="element-619">
              Our Commercial Services
            </h2>
            <div className="w-20 h-1 bg-brand-blue mx-auto mb-6 rounded-full" data-id="element-620"></div>
            <p className="font-body text-brand-gray text-lg" data-id="element-621">
              We provide comprehensive flat roof solutions tailored to the
              unique needs of commercial properties in Macomb, St. Clair, and
              Oakland counties.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-622">
            {services.map((service, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 hover:shadow-xl transition-all duration-300 group flex flex-col" data-id="element-623">
                <Link to={`/commercial/${service.slug}`} className="block relative aspect-[16/9] overflow-hidden" data-id="element-624">
                  <div className="brand-overlay h-full" data-id="element-625">
                    <img src={service.image} alt={service.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-626" />
                  </div>
                </Link>
                <div className="p-8 flex flex-col flex-grow" data-id="element-627">
                  <h3 className="font-heading font-bold text-2xl text-brand-gray-dark mb-4 group-hover:text-brand-blue transition-colors" data-id="element-628">
                    <Link to={`/commercial/${service.slug}`} data-id="element-629">
                      {service.title}
                    </Link>
                  </h3>
                  <p className="font-body text-brand-gray mb-6 flex-grow leading-relaxed" data-id="element-630">
                    {service.description}
                  </p>
                  <Link to={`/commercial/${service.slug}`} className="inline-flex items-center gap-2 text-brand-blue font-body font-bold hover:text-brand-blue-dark transition-colors mt-auto" data-id="element-631">
                    Learn More{' '}
                    <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" data-id="element-632" />
                  </Link>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      <ContactCTA data-id="element-633" />
    </div>;
}